import React, { useCallback, useEffect, useRef, useState } from "react";
import { Provider } from "react-redux";

import { initialize } from "../actions.js";
import { InitializationError } from "./initialization_error.js";
import AppContent from "./app_content.jsx";

export default function App({ store }) {

  const [state, setState] = useState("LOADING");
  const isUnmounted = useRef(false);

  const appInit = useCallback(async () => {
    try {
      await store.dispatch(initialize());
      if (!isUnmounted.current) {
        setState("READY");
      }
    } catch (error) {
      if (!isUnmounted.current) {
        setState("ERROR");
      }
    }
  }, [store]);

  useEffect(() => {
    appInit();

    return () => {
      isUnmounted.current = true;
    };
  }, [appInit]);

  if (state === "READY") {
    return (
      <Provider store={store}>
        <AppContent />
      </Provider>
    );
  }
  else if (state === "ERROR") {
    return <InitializationError />;
  }
  else {
    return null;
  }
}
